<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-relatorio-lancamentos') {
            next({ name: 'des-relatorio-lancamentos-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-relatorio-lancamentos') {
            this.$router.push({ name: 'des-relatorio-lancamentos-list' });
        }
    },
};
</script>
